import {
  getVisitorTypeAttributes,
  getGeographyAttributes,
  getAgeAttributes,
  getGenderAttributes,
  getEthnicityAttributes,
  getIntendedLevelofStudyAttributes,
  getEntryTermAttributes,
  getIntendedMajorAttributes,
  getGPAAttributes,
  getTestScoresAttributes,
  getEngagementAttributes,
  getListMembershipAttributes
} from ".";

export const getAttributesArray = (filter: any) => {
  return [
    getEngagementAttributes(filter.engagement),
    getListMembershipAttributes(filter.listMembership),
    getVisitorTypeAttributes(filter.demographics),
    getGeographyAttributes(filter.demographics),
    getAgeAttributes(filter.demographics),
    getGenderAttributes(filter.demographics),
    getEthnicityAttributes(filter.demographics),
    getIntendedLevelofStudyAttributes(filter.prospectProfile),
    getEntryTermAttributes(filter.prospectProfile),
    getIntendedMajorAttributes(filter.prospectProfile),
    getGPAAttributes(filter.prospectProfile),
    getTestScoresAttributes(filter.prospectProfile)
  ].filter(attributeObject => typeof attributeObject !== "undefined");
};
try {
    // @ts-ignore
    getAttributesArray.displayName = "getAttributesArray";
    // @ts-ignore
    getAttributesArray.__docgenInfo = { "description": "", "displayName": "getAttributesArray", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Attributes/utilities/getAttributesArray.ts#getAttributesArray"] = { docgenInfo: getAttributesArray.__docgenInfo, name: "getAttributesArray", path: "src/shared/containers/Attributes/utilities/getAttributesArray.ts#getAttributesArray" };
}
catch (__react_docgen_typescript_loader_error) { }